import { render } from "./SponsorNow.vue?vue&type=template&id=329cfba7&scoped=true"
import script from "./SponsorNow.vue?vue&type=script&lang=js"
export * from "./SponsorNow.vue?vue&type=script&lang=js"

import "./SponsorNow.vue?vue&type=style&index=0&id=329cfba7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-329cfba7"

export default script